import { v4 as uuidv4 } from 'uuid';

export class ChannelTeam {
    constructor() { }
    Id: string;
    DisplayName: string;
    Description: string;
}

export const mapToChannelTeam = (x: any): ChannelTeam => {
    return {
        Id: x.id,
        DisplayName: x.displayName,
        Description: x.description
    } as ChannelTeam;
}

export interface IntegrateChannelOptions {
    id: string,
    label: string
}


export const mapToIntegrateChannelOptions = (x: any): IntegrateChannelOptions => {
    return {
        id: x.id,
        label: x.displayName,
    } as IntegrateChannelOptions;
}

export class IntegrateChannelsData {
    constructor() { }
    Id: string;
    ChannelId: string;
    ChannelName: string;
    PhoneNumber: string;
    PhoneNumberId: string;
    TeamGuid: string;
    TeamName: string;
    provider: string;
    OrgId: string;
    OrgRef: string;
    UserId: string;
    ConversationRef: string;
    UserName: string;
    isEdit?: boolean;
    Status?: boolean;
}

export const mapToIntegrateChannelsData = (x: any) => {
    return {
        Id: uuidv4(),
        ChannelId: x.channelId,
        ChannelName: x?.channelName,
        PhoneNumber: x.phoneNumber,
        PhoneNumberId: x.phoneNumberId,
        TeamGuid: x.teamGUID,
        TeamName: x.teamName,
        provider: x.provider,
        OrgId: x.orgId,
        OrgRef: x.orgRef,
        UserId: x.userId,
        ConversationRef: x.conversationReference,
        UserName: x.userName,
        isEdit: false,
        Status: !!x?.phoneNumber?.trim() ? true : false,
    } as IntegrateChannelsData
}
